import { createUseExternalEvents } from '@mantine/utils';
import { DrawerSettings, OpenContextDrawer } from './context';

type DrawersEvents = {
  openDrawer(payload: DrawerSettings): void;
  closeDrawer(id: string): void;
  closeAllDrawers(): void;
  openContextDrawer(payload: OpenContextDrawer & { drawer: string }): void;
};

export const [useDrawersEvents, createEvent] =
  createUseExternalEvents<DrawersEvents>('modir-drawers');

export const openDrawer = createEvent('openDrawer');
export const closeDrawer = createEvent('closeDrawer');
export const closeAllDrawers = createEvent('closeAllDrawers');
export const openContextDrawer = createEvent('openContextDrawer');
